import { render, staticRenderFns } from "./intersection.observer.vue?vue&type=template&id=93aace38&"
import script from "./intersection.observer.vue?vue&type=script&lang=ts&"
export * from "./intersection.observer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports